import {
  MARIGRAM_SEARCH_CLEAR,
  MARIGRAM_SEARCH_REQUEST,
  MARIGRAM_SEARCH_CLEAR_REDIRECT,
  MARIGRAM_SEARCH_REGION_REQUEST,
  MARIGRAM_SEARCH_COUNTRY_REQUEST,
  MARIGRAM_SEARCH_LOCATION_REQUEST,
  MARIGRAM_SEARCH_STATE_REQUEST,
} from './marigramSearchReducer';
import {
  MARIGRAM_SEARCH_TOGGLE_SECTION,
} from './marigramSearchPageReducer';


export const searchMarigrams = ({
  queryParameters, formModel, location, searchRedirect, history,
}) => ({
  type: MARIGRAM_SEARCH_REQUEST, queryParameters, formModel, location, searchRedirect, history,
});

export const clearMarigramSearch = () => ({ type: MARIGRAM_SEARCH_CLEAR });
export const toggleSection = ({ section }) => ({ type: MARIGRAM_SEARCH_TOGGLE_SECTION, section });
export const clearRedirect = () => ({ type: MARIGRAM_SEARCH_CLEAR_REDIRECT });

export const getRegions = ({ history }) => ({ type: MARIGRAM_SEARCH_REGION_REQUEST, history });
export const getCountries = ({ history }) => ({ type: MARIGRAM_SEARCH_COUNTRY_REQUEST, history });
export const getLocations = ({ history }) => ({ type: MARIGRAM_SEARCH_LOCATION_REQUEST, history });
export const getStates = ({ country, history }) => ({ type: MARIGRAM_SEARCH_STATE_REQUEST, country, history });
